// extracted by mini-css-extract-plugin
module.exports = {"container":"DistrictTable_container__Rthbn","head":"DistrictTable_head__3CkUG","headside":"DistrictTable_headside__OLrki"};